// Shared Tailwind classes for a question block, kept in one place so the
// question types can't drift apart. Card values come from the design spec:
// background #FFFFFF66, border #EAECF0, shadow 0px 2px 4px 0px #0000000D.
export const QUESTION_CARD_BASE =
  'mb-6 rounded-lg border border-[#EAECF0] bg-[#FFFFFF66] p-4 shadow-[0px_2px_4px_0px_#0000000D]';

// Roomier vertical padding once there's space for it (the 20px/12px card);
// stays at a flat 16px on small screens.
export const QUESTION_CARD = `${QUESTION_CARD_BASE} md:pt-5 md:pb-3`;

export const QUESTION_TITLE = 'm-0 mb-4 text-[15px] font-semibold leading-[1.4] text-[#1D2939] md:text-base';

export const QUESTION_SUBTITLE = 'm-0 mb-4 text-sm italic text-[#6b7280]';

export const QUESTION_ERROR = 'mt-1 text-xs text-[#ef4444]';

// The option list the shared RadioInput renders into.
export const QUESTION_OPTIONS = 'flex flex-col mb-0';
